import { createApp, h } from "vue";
import route from "ziggy";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import Notifications from "notiwind";
import { plugin as Slicksort } from "vue-slicksort";
import PrimeVue from "primevue/config";
import plugins from "./plugins";
import usertour from "usertour.js";

// Initialize UserTour with your token
// usertour.init(process.env.USERTOUR_TOKEN);

// To identify the user after login:
// usertour.identify(userId, { name: userName, email: userEmail });

import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import InputNumber from "primevue/inputnumber";

import { createI18n } from "vue-i18n";
import { de } from "@/Shared/Locales/de";
import { en } from "@/Shared/Locales/en";

const i18n = createI18n({
    locale: "de",
    fallbackLocale: "de",
    legacy: false,
    messages: {
        de: de,
        en: en,
    },
});

require("./bootstrap");

const appName = window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./${name}.vue`).default,
    setup({ el, app, props, plugin }) {
        i18n.global.locale = props.initialPage.props.locale;
        const vueApp = createApp({
            render: () => h(app, props),
        })
            .use(plugin)
            .use(i18n)
            .use(PrimeVue)
            .use(Notifications)
            .use(Slicksort)
            .use(plugins);

        vueApp.config.globalProperties.$usertour = usertour;

        // Das Auswahl-Panel klappt IMMER nach unten auf (Entscheid Peter,
        // 31.08.2026). PrimeVue dreht es sonst nach oben, sobald unterhalb des
        // Feldes im Fenster zu wenig Platz ist (`DomHandler.absolutePosition`
        // setzt dann `origin = "bottom"`) — dabei verdeckte es die
        // Beschriftung des eigenen Feldes. Einen Schalter dafür gibt es nicht,
        // deshalb wird die Positionierung nach dem Ausrichten korrigiert.
        //
        // Preis dieser Wahl: steht das Feld ganz unten am Fensterrand, ragt die
        // Liste jetzt aus dem sichtbaren Bereich und man muss scrollen.
        const DropdownAlwaysBelow = {
            extends: Dropdown,
            methods: {
                alignOverlay() {
                    Dropdown.methods.alignOverlay.call(this);

                    if (!this.overlay || this.appendTo === "self") {
                        return;
                    }

                    const feld = this.$el.getBoundingClientRect();

                    this.overlay.style.top =
                        feld.bottom + (window.scrollY || window.pageYOffset) + "px";
                },
            },
        };

        vueApp.component("Dropdown", DropdownAlwaysBelow)
            .component("Calendar", Calendar)
            .component("InputNumber", InputNumber)
            .mixin({
                methods: {
                    route(name, params, absolute, config = this.$page.props.ziggy) {
                        return route(name, params, absolute, config);
                    },
                },
            })
            .mount(el);

        return vueApp;
    },
});

InertiaProgress.init({ color: "#4B5563" });
